import { useCallback } from 'react';
import { routes } from 'routes/routes';

export const usePathToVideoList = () => useCallback(() => routes.video.index, []);
